import axios from "axios";
// import swal from "sweetalert";
// import router from "@/router";
import { errorMessage, tokenExpired } from "@/api/errorMessages";
import * as api from "@/api/oauth";

export default {
  namespaced: true,
  state: {
    citiesInfo: null,
    expectedCost: null,
    xenonCityInfo: null
  },
  getters: {
    showCitiesInfo(state) {
      return state.citiesInfo;
    },
    showXenonCityInfo(state) {
      return state.xenonCityInfo;
    }
  },
  mutations: {
    setCitiesInfo(state, newCitiesInfo) {
      state.citiesInfo = newCitiesInfo;
    },
    setExpectedCost(state, newExpectedCost) {
      state.expectedCost = newExpectedCost;
    },
    setXenonCityInfo(state, newXenonCityInfo) {
      state.xenonCityInfo = newXenonCityInfo;
    }
  },
  actions: {
    async getCities({ commit }, info) {
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/xenon/info/cities?query=${info.query}&type=${info.type}`,
          api.getToken()
        );
        if (response.status == 200) {
          commit("setCitiesInfo", response.data);
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },
    async getPortsRamps(_, info) {
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/xenon/info/ports-ramps?city_id=${info.cityId}&piers_only=${info.piersOnly}&include_all_ports_ramps=${info.includeAllPortsRamps}`,
          api.getToken()
        );
        if (response.status == 200) {
          response.data;
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },
    async getTransationsTypes() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE + `/api/xenon/info/transations-types`,
          api.getToken()
        );
        if (response.status == 200) {
          response.data;
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },
    async getServicesTypes() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE + `/api/xenon/info/services-types`,
          api.getToken()
        );
        if (response.status == 200) {
          response.data;
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },
    async getContainerTypes() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE + `/api/xenon/info/container-types`,
          api.getToken()
        );
        if (response.status == 200) {
          response.data;
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },
    async getContainerSizes() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE + `/api/xenon/info/container-sizes`,
          api.getToken()
        );
        if (response.status == 200) {
          response.data;
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },
    async getXenon(_, info) {
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/xenon?transaction_type=${info.transactionType}&service_type=${info.serviceType}&container_type=${info.containerType}&origin_destination=${info.originDestination}&port_ramp=${info.portRamp}&container_size=${info.containerSize}&overweight=${info.overweight}&hazardous=${info.hazardous}`,
          api.getToken()
        );
        if (response.status == 200) {
          response.data;
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    }
  }
};
